module.exports = __webpack_public_path__ + "static/media/V2MastheadWebsite.1eb6f267.WebM";